import { render, staticRenderFns } from "./bf-wrapper.vue?vue&type=template&id=262b183b&scoped=true&lang=pug&"
import script from "./bf-wrapper.vue?vue&type=script&lang=js&"
export * from "./bf-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./bf-wrapper.vue?vue&type=style&index=0&id=262b183b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b183b",
  null
  
)

export default component.exports